/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialAnalyticsDashboardViewerResponse } from '../../models/editorial-analytics-dashboard-viewer-response';

export interface GetEditorialAnalyticsDashboardViewer$Params {
  companyId?: number;
}

export function getEditorialAnalyticsDashboardViewer(http: HttpClient, rootUrl: string, params?: GetEditorialAnalyticsDashboardViewer$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAnalyticsDashboardViewerResponse>> {
  const rb = new RequestBuilder(rootUrl, getEditorialAnalyticsDashboardViewer.PATH, 'get');
  if (params) {
    rb.query('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialAnalyticsDashboardViewerResponse>;
    })
  );
}

getEditorialAnalyticsDashboardViewer.PATH = '/api/editorial/analytics/dashboard-viewer';
